import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { User, LogOut, ShieldCheck, Menu } from "lucide-react";
import { useState } from "react";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/pays", label: t("nav.countries") },
    { to: "/tarifs", label: t("nav.pricing") },
  ];

  return (
    <header className="tc-glass sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <img src="/roadtogo-logo.png" alt="RoadToGo" className="h-10 w-auto object-contain" />
          <span className="text-[10px] tracking-[0.25em] uppercase text-[#8C857B] mt-1">Europe</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.to.slice(1)}`}
                  className="text-sm font-medium text-[#5C5854] hover:text-[#E06D53] transition-colors">
              {l.label}
            </Link>
          ))}
          {user && user !== false && (
            <Link to="/dashboard" className="text-sm font-medium text-[#5C5854] hover:text-[#E06D53] transition-colors" data-testid="nav-dashboard">
              {t("nav.dashboard")}
            </Link>
          )}
          {user?.role === "admin" && (
            <Link to="/admin" className="text-sm font-medium text-[#1D4E89] hover:text-[#E06D53] transition-colors flex items-center gap-1" data-testid="nav-admin">
              <ShieldCheck className="w-4 h-4" /> {t("nav.admin")}
            </Link>
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <LanguageSwitcher />
          {user && user !== false ? (
            <>
              <Button variant="ghost" onClick={() => navigate("/profil")} className="rounded-full" data-testid="nav-profile-btn">
                <User className="w-4 h-4 mr-1" /> {user.email.split("@")[0]}
              </Button>
              <Button onClick={() => { logout(); navigate("/"); }} variant="outline" className="rounded-full" data-testid="nav-logout-btn">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/connexion")} className="rounded-full" data-testid="nav-login-btn">{t("nav.login")}</Button>
              <Button onClick={() => navigate("/inscription")} className="rounded-full bg-[#E06D53] hover:bg-[#C95B42] text-white" data-testid="nav-register-btn">
                {t("nav.start")}
              </Button>
            </>
          )}
        </div>

        <div className="md:hidden flex items-center gap-2">
          <LanguageSwitcher />
          <button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            <Menu className="w-6 h-6 text-[#2C2A28]" />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-[#FAF9F6] px-5 py-4 flex flex-col gap-3">
          {links.map((l) => <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm text-[#5C5854]">{l.label}</Link>)}
          {user && user !== false && <Link to="/dashboard" onClick={() => setOpen(false)} className="text-sm text-[#5C5854]">{t("nav.dashboard")}</Link>}
          {user?.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="text-sm text-[#1D4E89]">{t("nav.admin")}</Link>}
          <div className="flex gap-2 pt-2">
            {user && user !== false ? (
              <>
                <Button variant="outline" className="rounded-full flex-1" onClick={() => { navigate("/profil"); setOpen(false); }}>{t("dashboard.t3")}</Button>
                <Button className="rounded-full flex-1 bg-[#E06D53] text-white" onClick={() => { logout(); navigate("/"); setOpen(false); }}>{t("nav.login")}</Button>
              </>
            ) : (
              <>
                <Button variant="outline" className="rounded-full flex-1" onClick={() => { navigate("/connexion"); setOpen(false); }}>{t("nav.login")}</Button>
                <Button className="rounded-full flex-1 bg-[#E06D53] text-white" onClick={() => { navigate("/inscription"); setOpen(false); }}>{t("nav.start")}</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
